import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d414210"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "banner-box" }
const _hoisted_2 = ["src"]

import { onMounted, reactive } from 'vue';
import { searchInfo } from '@/api/request';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const bannerList = reactive([]);
onMounted(() => {
  getBanner();
});
const toUrl = (item: any) => {
  searchInfo.clickBanner(item.id);

  if (item.jump_url!) {
    window.open(item.jump_url);
  }
};

const _isMobile = () => {
  const flag = navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  );
  return flag;
};
const getBanner = () => {
  searchInfo.searchBanner().then((res) => {
    bannerList.values = res.body;
  });
};

return (_ctx: any,_cache: any) => {
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(bannerList).values.length)
      ? (_openBlock(), _createBlock(_component_el_carousel, {
          key: 0,
          interval: 4000,
          height: _isMobile() ? '500px' : '900px',
          arrow: "always"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bannerList).values, (item) => {
              return (_openBlock(), _createBlock(_component_el_carousel_item, {
                key: item,
                onClick: ($event: any) => (toUrl(item))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    src: 
            'https://yzims.oss-cn-shenzhen.aliyuncs.com/' +
            (_isMobile() ? item.banner_url_mobile : item.banner_url_pc)
          ,
                    alt: ""
                  }, null, 8, _hoisted_2)
                ]),
                _: 2
              }, 1032, ["onClick"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["height"]))
      : _createCommentVNode("", true)
  ]))
}
}

})